<template>
  <div class="topup-online">
    <div class="item">
      <div class="title">{{ $t('currentBalance') }}</div>
      <div class="desc balance">
        {{ accountInfo.balance ? accountInfo.balance : 0 | formatMoney }}
      </div>
    </div>
    <div class="item">
      <div class="title">{{ $t('topupAmount') }}</div>
      <div class="desc">
        <md-field>
          <md-input-item
            ref="amount"
            name="amount"
            title=""
            type="money"
            v-model="topupForm.amount"
            v-validate="{ required: true, min_value:50000, max_value:999999999 }"
            :error="errors.first('amount')"
            class="input-money-container bordered"
          >
            <cleave slot="left" v-model="topupForm.amount" :options="amountFormatOptions"
                    class="input-money-inner"></cleave>
          </md-input-item>
        </md-field>
      </div>
    </div>
    <div class="item">
      <div class="title">{{ $t('paymentMethod') }}</div>
      <div class="desc payment-selector">
        <md-radio-list
          ref="radio"
          :options="paymentMethodOptions"
          v-model="paymentMethod"
          icon-position="left"
        >
          <template slot-scope="{ option }">
            <div class="payment-content">
              <img class="pay-icon" :src="option.icon">
              <div class="pay-text" v-text="option.text"></div>
            </div>
          </template>
        </md-radio-list>
      </div>
    </div>
    <div class="item">
      <div class="title"></div>
      <div class="desc">
        <button-primary type="primary" :loading="loading" @click="submitTopup">
          {{ $t('next') }}
        </button-primary>
      </div>
    </div>
  </div>
</template>

<script>
import { RadioList, Field, InputItem, Button, Tabs } from 'mand-mobile'
import Cleave from 'vue-cleave-component'
import { amountOptions } from '@/lib/cleave'

export default {
  i18n: {
    messages: {
      en: {
        currentBalance: 'Your Balance',
        topupAmount: 'Topup Amount',
        paymentMethod: 'Payment Method',
        // bca: 'For BCA accounts only, every transaction VA number will be different',
        bca: 'For BCA accounts only, every transaction using the same VA',
        bni: 'Accept from all bank accounts',
        next: 'Next',
      },
      id: {
        currentBalance: 'Nominal Anda',
        topupAmount: 'Penyaluran Dana',
        paymentMethod: 'Cara Pembayaran',
        // bca: 'Hanya dari akun BCA, nomor VA berubah setiap transaksi',
        bca: 'Hanya dari akun BCA, menggunakan nomor VA yang sama setiap transaksi',
        bni: 'Menerima dari semua akun bank',
        next: 'Berikutnya',
      },
    },
  },
  components: {
    [RadioList.name]: RadioList,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    Cleave,
  },
  data() {
    return {
      defaultIndex: 0,
      amountFormatOptions: amountOptions,
      paymentMethodOptions: [
        {
          icon: require('@/assets/image/user/topup/logo-bca.png'),
          text: this.$t('bca'),
          value: 'bca',
        },
        {
          icon: require('@/assets/image/user/topup/logo-bni.png'),
          text: this.$t('bni'),
          value: 'bni',
        },
      ],
      paymentMethod: 'bca',
      topupForm: {
        amount: '',
      },
      topupData: {
        currentBalance: 0,
        account: {},
      },
      currencyType: 'IDR',
      showMessage: false,
      validateMessage: {
        en: {
          custom: {
            amount: {
              min_value: (field, value) => `At least ${this.$options.filters.formatMoney(value)}`,
            },
          },
        },
        id: {
          custom: {
            amount: {
              min_value: (field, value) => `At least ${this.$options.filters.formatMoney(value)}`,
            },
          },
        },
      },
      loading: false,
    }
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountOverview.find(data => {
        return this.currencyType === data.currencyType
      }) || {}
    },
  },
  mounted() {
    this.appendSnapScript()
    this.$validator.localize(this.validateMessage)
  },
  methods: {
    appendSnapScript() {
      const snapScript = document.createElement('script')
      snapScript.setAttribute('src', this.$config.snapInfo.snapUrl)
      snapScript.setAttribute('data-client-key', this.$config.snapInfo.snapToken)

      document.head.appendChild(snapScript)
    },
    async submitTopup() {
      if (window.bridge && window.bridge.afTrackEvent) {
        window.bridge.afTrackEvent('top-up', '')
      }
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.$router.push({ name: 'UserTopup', query: { type: this.paymentMethod, amount: this.topupForm.amount } })
      // if (this.paymentMethod === 'bni') {
      //   this.$router.push({ name: 'UserTopup', query: { type: this.paymentMethod, amount: this.topupForm.amount } })
      // } else {
      //   try {
      //     const payload = {
      //       referenceId: this.$store.state.userInfo.id,
      //       amount: this.topupForm.amount,
      //       currencyType: 'IDR',
      //     }
      //     this.$toast.loading('loading...')
      //     const response = await this.$http.post('/invested-payment-api/payment/1/invoice', payload)
      //     window.snap.pay(response.data.data.token, {
      //       onSuccess: result => {
      //         if (window.bridge && window.bridge.afTrackEvent) {
      //           window.bridge.afTrackEvent('top-up succeed', '')
      //         }
      //         this.$router.push({ name: 'UserTopupResult', query: { type: 'success' } })
      //       },
      //       onPending: result => this.$router.push({ name: 'UserTopupResult', query: { type: 'process' } }),
      //       onError: result => this.$router.push({ name: 'UserTopupResult', query: { type: 'fail' } }),
      //       onClose: () => console.log('Customer closed the popup without finishing the payment'),
      //     })
      //     // window.location.replace(response.data.data.redirectUrl)
      //   } catch (error) {
      //     console.error(error)
      //   } finally {
      //     this.$toast.hide()
      //   }
      // }
    },
  },
}
</script>

<style lang="stylus" scoped>
.topup-online {
  padding: 30px 20px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 26px;
    .title {
      font-size: 14px;
      color: #555;
      margin-bottom: 10px;
    }
    .desc {
      width: 100%;
      font-size: 14px;
      &.balance {
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #101010;
      }
    }
  }
}

.payment-selector /deep/ {
  .md-radio-list {
    .md-radio-item {
      .md-cell-item-body {
        padding: 0;
        min-height: 40px;
        &::before {
          height: 0;
        }
        .md-cell-item-left {
          margin-right: 12px;
        }
      }
      .md-field-item-inner {
        padding: 10px 0;
        &::before {
          background-color: unset;
        }
      }
    }
  }
  .payment-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .pay-icon {
      width: 58px;
      min-width: 58px;
      height: 20px;
      margin-right: 14px;
    }
    .pay-text {
      font-size: 10px;
    }
  }
}
</style>
